import { ReactNode } from 'react'
import { BsInputCursor } from 'react-icons/bs'
import { CiFileOn } from 'react-icons/ci'
import { LuFrame } from 'react-icons/lu'
import { MdSmartButton } from 'react-icons/md'
import { MdTextFields } from 'react-icons/md'

export const getIcon = (uiType: string): ReactNode => {
  if (uiType === 'INPUT' || uiType === 'INPUT_ADDON') {
    return <BsInputCursor size={14} />
  }

  if (uiType === 'MAIN_DIV' || uiType === 'DIV' || uiType === 'FORM2X3' || uiType === 'FORM2X2') {
    return <LuFrame size={14} />
  }

  if (uiType === 'H') {
    return <MdTextFields size={14} />
  }

  if (uiType === 'BUTTON') {
    return <MdSmartButton size={14} />
  }

  return <CiFileOn size={14} />
}
